import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { ExperimentIds } from "../commons/constants/experiment";
import { isControlCohort } from "./helper";

export function useExperiment(experimentId: ExperimentIds) {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === experimentId;
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);

  useEffect(() => {
    if (!inExperiment) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: {
        inTreatmentCohort,
      },
    });
  }, [inExperiment, landerConfigDispatch, inTreatmentCohort]);

  return { inTreatmentCohort, inExperiment, cohort };
}
